import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import Axios from "axios";
import url from "../../services/url";
import LoadingArea from "../../components/LoadingArea";
import { useHistory } from "react-router-dom";
import axios from "../../services/axios";
import RSelect from "react-select";
import RDatePicker from "react-datepicker";
import saveLog from "../../services/saveLog";
import isConsultant from "../../services/isConsultant";

function ApplicationList() {
  // States
  const [loading, setLoading] = useState(true);
  const [candidates, setCandidates] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  // Effects
  useEffect(() => {
    loadCandidates();
  }, []);

  async function loadCandidates() {
    try {
      const res = await Axios.get(url("candidates/new"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setCandidates(res.data.candidates);
      setLoading(false);
      setTotalPages(res.data.totalPages);
    } catch (e) {
      console.log(e);
    }
  }

  async function onPaginate(page) {
    try {
      const res = await axios.get("candidates/new?page=" + page, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setCandidates(res.data.candidates);
      setLoading(false);
      setTotalPages(res.data.totalPages);
    } catch (e) {
      console.log(e);
    }
  }

  function setStatus(candidate, status) {
    Axios.put(
      url("candidates/" + candidate.id),
      {
        [status]: true,
        newCandidate: false,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    ).catch(console.error);
  }

  function onApproveCandidate(candidate) {
    saveLog("CANDIDATE_EDIT", `Approved for screening ${candidate.name}`);
    setStatus(candidate, "screened");
    loadCandidates();
    window.location.reload();
  }

  return (
    <div>
    {!isConsultant() && <Dashboard title="New Candidates">
      <LoadingArea isLoading={loading}>
        <CandidatesTable
          candidates={candidates}
          setCandidates={setCandidates}
          onPaginate={onPaginate}
          totalPages={totalPages}
          setApproved={(candidate) => {
            setStatus(candidate, "screened");
          }}
          reloadCandidates={loadCandidates}
          controls={(candidate) => {
            return (
              <>
                <button
                  className="btn btn-sm btn-primary btn-table-control mx-1"
                  candidate={candidate.id}
                  onClick={() => onApproveCandidate(candidate)}
                >
                  Approve For Screening
                </button>
              </>
            );
          }}
        />
      </LoadingArea>
    </Dashboard>}
    </div>
  );
}

function CandidatesTable({
  candidates,
  setCandidates,
  hideFilter = [],
  controls,
  setApproved,
  reloadCandidates,
}) {
  // Stateful Hooks
  const pageCount = 10;
  const totalPages = Math.ceil(candidates.length / pageCount);
  const [page, setPage] = useState(0);
  const [positionFilter, setPositionFilter] = useState();
  const [locationFilter, setLocationFilter] = useState();
  const [statusFilter, setStatusFilter] = useState();
  const [startDateFilter, setStartDateFilter] = useState();
  const [endDateFilter, setEndDateFilter] = useState();
  const [showID, setShowID] = useState(true);
  const [search, setSearch] = useState("");
  const history = useHistory();
  const [sort, setSort] = useState();
  const [sortOrder, setSortOrder] = useState(0);
  const [selected, setSelected] = useState([]);
  const [bulkActionLoading, setBulkActionLoading] = useState(false);
  const [checkAll, setCheckAll] = useState(false);

  // Effects
  useEffect(() => {
    setShowID(false);
  }, [candidates]);

  useEffect(() => {
    if (checkAll) {
      setSelected(candidates.map((c) => c.id));
    } else {
      setSelected([]);
    }
  }, [checkAll]);

  // Events
  function toggleSortOrder() {
    if (sortOrder === 0) {
      setSortOrder(1);
    } else if (sortOrder === 1) {
      setSortOrder(-1);
    } else if (sortOrder === -1) {
      setSortOrder(0);
    } else {
      setSortOrder(0);
    }
  }

  function onClickView(event) {
    const id = event.target.getAttribute("candidate");
    history.push("/candidate/" + id);
  }

  function onClickDelete(event) {
    const id = event.target.getAttribute("candidate");
    axios
      .delete("candidates/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setCandidates((previousCandidates) => {
          return previousCandidates.filter((candidate) => {
            if (candidate.id === id) {
              return false;
            }
            return true;
          });
        });
      })
      .catch(console.error);
  }
  function onClickDownloadCSV() {
    let rows = [
      [
        "Name",
        "Email",
        "Phone Number",
        "Date Applied",
        "Gender",
        "Location Applied For",
        "State",
        "Highest Qualification",
        "Languages Known",
        "Experience In",
        "Source",
      ],
      ...candidates.map((candidate) =>
        Object.values(candidate.personalDetails)
      ),
    ];
    let csv =
      "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");
    var encodedUri = encodeURI(csv);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "candidates.csv");
    document.body.appendChild(link); // Required for FF
    link.click();
  }

  function onClickDownloadCSVOld(event) {
    let candidates = [];
    let rows = [];
    // let rows = $("#table-datatable")
    //   .DataTable()
    //   .rows({ search: "applied" })
    //   .nodes();
    for (let i = 0; i < rows.length; i++) {
      const candidate = JSON.parse(rows[i].getAttribute("candidate"));
      candidates.push(candidate);
    }
    rows = [];
    rows.push(Object.keys(candidates[0]));
    candidates.forEach((candidate) => {
      rows.push(
        Object.values(candidate).map((value) => {
          return '"' + value + '"';
        })
      );
    });
    let csv =
      "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");
    var encodedUri = encodeURI(csv);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "candidates.csv");
    document.body.appendChild(link); // Required for FF
    link.click();
  }

  function onClickClearFilters() {
    setLocationFilter();
    setPositionFilter();
    setStatusFilter();
    setStartDateFilter();
    setEndDateFilter();
    setSearch("");
  }

  function onClickToggleID() {
    setShowID(!showID);
  }

  function camel2normal(str) {
    return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    });
  }

  function reactSelectOptionMap(list, key) {
    let temp = list.map((item) => {
      return item[key];
    });
    temp = [...new Set(temp)].map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    return temp;
  }

  function onBulkApproveCandidates() {
    setBulkActionLoading(true);
    selected.forEach(async (candidateId) => {
      await setApproved({ id: candidateId });
    });
    reloadCandidates();
    setBulkActionLoading(false);
    setSelected([]);
  }

  let positionOptions = reactSelectOptionMap(candidates, "position");
  let locationOptions = reactSelectOptionMap(candidates, "location");
  let statusOptions = reactSelectOptionMap(candidates, "status");

  if (candidates.length <= 0) {
    return (
      <h4 className="text-primary text-center">
        There are no candidates to show.
      </h4>
    );
  }

  let candidateFields = Object.keys(candidates[0]).filter((field) => {
    if (field == "id") return false;
    if (field == "personalDetails") return false;
    let hide = false;
    hideFilter.forEach((filter) => {
      if (field == filter) hide = true;
    });
    if (hide === true) return false;
    return true;
  });

  // fiter keys from object
  // const filteredKey = candidates.map(ele => {
  //   return Object.keys(ele.personalDetails)
  // })

  return (
    <div>
    {!isConsultant() && <div className="row">
      <div className="col-lg-9 col-md-12 col-sm-12">
        <div className="table-responsive">
          <table className="table bg-white">
            <thead className="table-head">
              <tr>
                <td>
                  <input
                    type="checkbox"
                    checked={checkAll}
                    onChange={() => {
                      setCheckAll((b) => !b);
                    }}
                  />
                </td>
                {showID ? <td>ID</td> : null}
                {candidateFields.map((field, key) => (
                  <td className="table-column-head" key={key}>
                    {camel2normal(field)}{" "}
                    <i
                      onClick={() => {
                        if (sort === field) {
                          toggleSortOrder();
                        } else {
                          setSort(field);
                        }
                      }}
                      className={
                        sort === field
                          ? sortOrder === 0
                            ? "sort fas fa-fw sort-focus fa-sort-up"
                            : sortOrder === 1
                            ? "sort fas fa-fw sort-focus fa-sort-down"
                            : "sort fas fa-fw sort-focus fa-sort"
                          : "sort fas fa-fw fa-sort"
                      }
                      // fas fa-fw fa-sort
                    ></i>
                  </td>
                ))}
                <td style={{ minWidth: "15%" }}>Actions</td>
              </tr>
            </thead>
            <tbody>
              {candidates
                // Search
                .filter((candidate) => {
                  if (search === "" || search.length < 3) return true;
                  let candidateContainsSearch = false;
                  let candidateValues = Object.values(candidate);
                  candidateValues.forEach((value) => {
                    if (typeof value !== "string") return;
                    if (
                      value.toLowerCase().indexOf(search.toLowerCase()) != -1
                    ) {
                      candidateContainsSearch = true;
                    }
                  });
                  return candidateContainsSearch;
                })
                // Filters
                .filter((candidate) => {
                  if (positionFilter != null) {
                    if (candidate.position !== positionFilter) {
                      return false;
                    }
                  }
                  if (locationFilter != null) {
                    if (candidate.location !== locationFilter) {
                      return false;
                    }
                  }
                  if (statusFilter != null) {
                    if (candidate.status !== statusFilter) {
                      return false;
                    }
                  }
                  if (startDateFilter != null && endDateFilter != null) {
                    const applicationDate = new Date(candidate.dateApplied);
                    if (startDateFilter > applicationDate) {
                      return false;
                    }
                    if (endDateFilter < applicationDate) {
                      return false;
                    }
                  }

                  return true;
                })
                // Sorts
                .sort((a, b) => {
                  if (sort == null) {
                    return 0;
                  }
                  if (sortOrder === 0) {
                    return 0;
                  }

                  // Return Value of the comparison function
                  let comparison = 0;
                  let valueA = (a[sort] + "").toLowerCase();
                  let valueB = (b[sort] + "").toLowerCase();

                  comparison = valueA > valueB ? 1 : -1;

                  // Invert comparison on the basis of sortOrder
                  if (sortOrder === -1) {
                    if (comparison === -1) {
                      comparison = 1;
                    } else if (comparison === 1) {
                      comparison = -1;
                    }
                  }
                  return comparison;
                })
                // Pagination
                .slice(page * pageCount, page * pageCount + pageCount)
                // Output Map
                .map((candidate, k) => (
                  <tr
                    key={k}
                    candidate={JSON.stringify(candidate.personalDetails)}
                    className={
                      selected.includes(candidate.id) ? "selected" : null
                    }
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(candidate.id)}
                        onChange={() => {
                          if (selected.includes(candidate.id)) {
                            setSelected([
                              ...selected.filter(
                                (selectedCandidate) =>
                                  selectedCandidate != candidate.id
                              ),
                            ]);
                          } else {
                            setSelected([...selected, candidate.id]);
                          }
                        }}
                      />
                    </td>
                    {showID ? <td>{candidate.id}</td> : null}
                    {candidateFields.map((field, key) => (
                      <td
                        key={key}
                        className="table-candidate-column table-column"
                      >
                        {candidate[field]}
                      </td>
                    ))}
                    <td className="table-candidate-column table-column table-control">
                      {controls ? (
                        controls(candidate)
                      ) : (
                        <>
                          <button
                            className="btn btn-sm btn-primary btn-table-control mx-1"
                            candidate={candidate.id}
                            onClick={onClickView}
                          >
                            View
                          </button>
                          <button
                            className="btn btn-sm btn-danger btn-table-control mx-1"
                            candidate={candidate.id}
                            onClick={onClickDelete}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex">
          <div>
            {selected.length > 0 && (
              <button
                className="btn btn-primary btn-sm"
                onClick={onBulkApproveCandidates}
                disabled={bulkActionLoading}
              >
                {bulkActionLoading
                  ? "Applying Bulk Approve"
                  : `Bulk Approve For Screening (Selected ${selected.length})`}
              </button>
            )}
          </div>
          <div className="ml-auto">
            <button
              className={"btn btn-sm btn-primary mr-2"}
              disabled={page - 1 < 0}
              onClick={() => {
                if (page - 1 < 0) return;
                setPage(page - 1);
                // onPaginate(page - 1);
              }}
            >
              Previous
            </button>
            <button
              className={"btn btn-sm btn-primary"}
              disabled={totalPages - 1 < page + 1}
              onClick={() => {
                if (totalPages - 1 < page + 1) {
                  return;
                }
                setPage(page + 1);
                // onPaginate(page + 1);
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-12 col-sm-12">
        <h6 className="text-dark" placeholder="Enter something...">
          Search
        </h6>
        <input
          className="form-control mb-3"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <h6 className="text-dark">Filters</h6>
        <div className="">
          <h6 className="text-primary">Location</h6>
          <RSelect
            options={locationOptions}
            onChange={(selected) => setLocationFilter(selected.value)}
          />
        </div>
        <div className="my-4">
          <h6 className="text-primary">Position</h6>
          <RSelect
            options={positionOptions}
            onChange={(selected) => setPositionFilter(selected.value)}
          />
        </div>
        {/* <div className="my-4">
          <h6 className="text-primary">Status</h6>
          <RSelect
            options={statusOptions}
            onChange={(selected) => setStatusFilter(selected.value)}
          />
        </div> */}
        <div className="my-4">
          <h6 className="text-primary">Application Date</h6>
          <RDatePicker
            // className="form-control"
            selected={startDateFilter}
            startDate={startDateFilter}
            endDate={endDateFilter}
            onChange={(dates) => {
              const [start, end] = dates;
              setStartDateFilter(start);
              setEndDateFilter(end);
            }}
            selectsRange
            inline
          />
        </div>
        <div className="mt-4">
          <button
            className="btn btn-primary btn-block"
            onClick={onClickClearFilters}
          >
            Clear Filters
          </button>
          <button
            className="btn btn-primary btn-block"
            onClick={onClickToggleID}
          >
            {showID ? "Hide ID" : "Show ID"}
          </button>
          <button
            className="btn btn-primary btn-block"
            onClick={onClickDownloadCSV}
          >
            Download CSV
          </button>
        </div>
      </div>
    </div>}
    </div>
  );
}

export default ApplicationList;
